import { IconPen, IconPlusRounded, IconTrash } from "@aksara-ui/icons";
import {
  TableHeadCell,
  Box,
  Button,
  Card,
  Stack,
  Table,
  TableHead,
  TableHeadRow,
  Text,
  TableBody,
  TableBodyRow,
  TableBodyCell,
  Anchor,
  theme,
  Badge,
  IconButton,
} from "@aksara-ui/react";
import { useMediaQuery } from "react-responsive";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllMedias,
  setModalConfirmationOpen,
  setModalFormOpen,
} from "redux/actions";
import { MediaConfirmationModal, MediaFormModal } from "./components";
import { LazyLoadImage } from "react-lazy-load-image-component";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 30px;
  gap: 20px;
`;

const MediaContent: React.FC = () => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 576 });

  const { appUrl, isLoading, isModalFormOpen, isModalConfirmationOpen } =
    useSelector((state: any) => state.globalReducer);
  const { medias } = useSelector((state: any) => state.mediaReducer);

  const [selectedMediaId, setSelectedMediaId] = useState("");

  const handleOpenFormModal = (mediaId: string = "") => {
    dispatch(setModalFormOpen(true) as any);
    setSelectedMediaId(mediaId);
  };

  const handleCloseFormModal = () => {
    dispatch(setModalFormOpen(false) as any);
    setSelectedMediaId("");
  };

  const handleOpenConfirmModal = (mediaId: string) => {
    dispatch(setModalConfirmationOpen(true) as any);
    setSelectedMediaId(mediaId);
  };

  const handleCloseConfirmModal = () => {
    dispatch(setModalConfirmationOpen(false) as any);
    setSelectedMediaId("");
  };

  useEffect(() => {
    // if (!medias.length) {
    dispatch(getAllMedias() as any);
    // }
  }, [dispatch]);

  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <HeaderWrapper
        display={"flex"}
        flexDirection={isMobile ? "column" : "row"}
        alignItems={isMobile ? "left" : "center"}
      >
        <Box display={"flex"}>
          <Text scale={[500, 600]} fontWeight={700}>
            Media Management
          </Text>
        </Box>

        <Box display={"flex"}>
          <Stack display={"flex"} flexDirection={"row"} style={{ gap: 10 }}>
            <Button
              variant={"primary"}
              borderRadius={10}
              style={{ fontWeight: 600 }}
              icon={IconPlusRounded}
              iconPosition={"left"}
              size={32}
              onClick={() => handleOpenFormModal()}
            >
              Add Media
            </Button>
          </Stack>
        </Box>
      </HeaderWrapper>

      <Card overflow={"auto"} elevation={2} maxHeight={"100%"}>
        <Table>
          <TableHead position={"sticky"} top={0} backgroundColor={"white"}>
            <TableHeadRow>
              <TableHeadCell>Image</TableHeadCell>
              <TableHeadCell>Name</TableHeadCell>
              <TableHeadCell>Link</TableHeadCell>
              <TableHeadCell>Wording</TableHeadCell>
              <TableHeadCell>Status</TableHeadCell>
              <TableHeadCell>Action</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={6} />
            ) : !medias.length ? (
              <TableBodyRow>
                <TableBodyCell colSpan={6} textAlign={"center"}>
                  No data available in table
                </TableBodyCell>
              </TableBodyRow>
            ) : (
              medias.map((media: any) => {
                return (
                  <TableBodyRow key={media.id}>
                    <TableBodyCell>
                      {media.image ? (
                        <LazyLoadImage
                          key={media.id}
                          src={`${appUrl}/storage/${media.image}`}
                          alt="media-image "
                          width={200}
                          height={"100%"}
                          effect="blur"
                        />
                      ) : (
                        ""
                      )}
                    </TableBodyCell>
                    <TableBodyCell>{media.name}</TableBodyCell>
                    <TableBodyCell>
                      <Anchor
                        color={theme.colors.blue07}
                        target={"_blank"}
                        href={media.link}
                        fontWeight={500}
                        scale={[200, 300]}
                      >
                        {media.link}
                      </Anchor>
                    </TableBodyCell>
                    <TableBodyCell>{media.wording}</TableBodyCell>
                    <TableBodyCell whiteSpace={"nowrap"}>
                      <Badge
                        size={"md"}
                        variant={media.status === 1 ? "success" : "critical"}
                      >
                        {media.status === 1 ? "Active" : "Non Active"}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell>
                      <IconButton onClick={() => handleOpenFormModal(media.id)}>
                        <IconPen fill={theme.colors.green06} />
                      </IconButton>
                      <IconButton
                        onClick={() => handleOpenConfirmModal(media.id)}
                      >
                        <IconTrash fill={theme.colors.red06} />
                      </IconButton>
                    </TableBodyCell>
                  </TableBodyRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Card>

      <MediaFormModal
        mediaId={selectedMediaId}
        isOpen={isModalFormOpen}
        onClose={() => handleCloseFormModal()}
      />

      <MediaConfirmationModal
        mediaId={selectedMediaId}
        isOpen={isModalConfirmationOpen}
        onClose={() => handleCloseConfirmModal()}
      />
    </Box>
  );
};

export default MediaContent;
